// Exécute `fn` une seule fois : après l'événement `load` puis à l'inactivité du
// navigateur, ou plus tôt à la première interaction (scroll, toucher, clavier).
// Extrait de lazy_iframe_controller pour être testable sans DOM (cf.
// spec/javascript/defer_until_idle.test.js). Renvoie une fonction d'annulation.
const INTERACTIONS = ["pointerdown", "touchstart", "keydown", "scroll"]

export function deferUntilIdle(win, fn, { timeout = 2500 } = {}) {
  let done = false
  let idle = null

  const cleanup = () => {
    INTERACTIONS.forEach(name => win.removeEventListener(name, run))
    win.removeEventListener("load", schedule)
    if (idle !== null) (win.cancelIdleCallback || win.clearTimeout)(idle)
    idle = null
  }
  function run() {
    if (done) return
    done = true
    cleanup()
    fn()
  }
  function schedule() {
    // Safari n'a pas requestIdleCallback : un court délai après `load` suffit.
    idle = win.requestIdleCallback ? win.requestIdleCallback(run, { timeout }) : win.setTimeout(run, 200)
  }

  INTERACTIONS.forEach(name => win.addEventListener(name, run, { passive: true }))
  if (win.document.readyState === "complete") schedule()
  else win.addEventListener("load", schedule)

  return cleanup
}
